<app-order-list viewMode="DASHBOARD" [showSelectionStatusFilter]='true'>

</app-order-list>
